import { render } from "./ContractorIQPStatementTemplate.vue?vue&type=template&id=bcfa2074&scoped=true&ts=true"
import script from "./ContractorIQPStatementTemplate.vue?vue&type=script&lang=ts"
export * from "./ContractorIQPStatementTemplate.vue?vue&type=script&lang=ts"

import "./ContractorIQPStatementTemplate.vue?vue&type=style&index=0&id=bcfa2074&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfa2074"]])

export default __exports__